/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CheckListViewModel } from "../types/CheckListViewModel.ts";

export const checkListViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  name: z.string().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<CheckListViewModel>;
